/*
 * AppBar.jsx 05.12.2017
 *
 * (c) 2017 ergovia GmbH
 */
import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import MuiAppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import InputIcon from '@material-ui/icons/Input';
import Button from '@material-ui/core/Button';

const styles = () => ({
    toolbar: {
        display: 'grid',
        gridTemplateColumns: '50% 50%',
        gridTemplateAreas: '"title exit"'
    },
    toolbarTitle: {
        fontSize: '1.4rem',
        textTransform: 'uppercase',
        flex: 1,
        gridArea: 'title'
    },
    logout: {
        position: 'absolute',
        right: 16,
        gridArea: 'exit'
    },
    exitButton: {
        margin: '0px -40px'
    },
    buttonIcon: {
        marginTop: -2
    },
    buttonText: {
        margin: 7,
        textAlign:'right',
        fontSize: '14px'
    }
});

/**
 * Komponente für die Navigationsleiste des Bildungsmanagers. Beinhaltet die Darstellung des Zeitraums und der ausgewählten Sortierung
 */
class AppBar extends React.Component {

    render() {
        const {classes} = this.props;

        return (
            <MuiAppBar position="fixed">
                <Toolbar variant="dense" className={classes.toolbar}>
                    <Typography type="headline" className={classes.toolbarTitle}>Bildungsmanager</Typography>

                    <div className={classes.logout}>
                        <Button className={classes.exitButton} onClick={() => window.close()}>
                            <Typography className={classes.buttonText} type="button" color="inherit">verlassen</Typography>
                            <InputIcon className={classes.buttonIcon}/>
                        </Button>
                    </div>
                </Toolbar>
            </MuiAppBar>
        );
    }
}

export default withStyles(styles)(AppBar);



// WEBPACK FOOTER //
// ./src/de/ergovia/components/AppBar.jsx